/**
 * @author Denis Sobolev, Ryan Gladstone, Umer Hassan
 */

function TwpBreadcrumbsController(
  $scope,
  $log,
  $translate,
  siteService,
  platformService,
  $q
) {
  $scope.allLabel = $translate.instant('ALL_M');
  $scope.sectionsFilter = $scope.filterSet.getFilter('sections');
  $scope.platformsFilter = $scope.filterSet.getFilter('platforms');
  $scope.hierarchyFilter = $scope.filterSet.getFilter('hierarchy');

  const initWatch = (websiteId) => {
    $q.all([
      siteService.getSections(websiteId),
      platformService.getAll(websiteId)
    ]).then(() => {
      $scope.$watch('platformsFilter.value', $scope.updateView);
      $scope.$watch('sectionsFilter.value', $scope.updateView);
      $scope.$watch('hierarchyFilter.value', $scope.updateView);
    }, (response) => {
      $log.error('Error getting plans for breadcrumbs', response);
    });
  };

  const selectedWebsite = siteService.getSelectedWebsite();
  if (selectedWebsite) {
    initWatch(selectedWebsite._id);
  } else {
    siteService.getDefaultWebsite()
      .then((website) => {
        initWatch(website._id);
      });
  }

  $scope.bakeBreadcrumbs = () => {
    const fil = $scope.filterSet.getFilter($scope.searchType);
    let filVal = fil.value;
    if (_.isArray(filVal) && filVal.length < 2) {
      filVal = filVal[0];
    }

    const currentPlanFromUrl = filVal;

    $scope.breadcrumbs = {};
    $scope.breadcrumbs.middle = [];

    const planFound = $scope.plans.find(plan => (plan.path || plan._id) === currentPlanFromUrl);
    if (currentPlanFromUrl && !_.isArray(currentPlanFromUrl) && planFound) {
      $scope.breadcrumbs.middle.push(planFound);
    } else if (_.isArray(currentPlanFromUrl)) {
      $scope.breadcrumbs.terminal = {
        selectedPlans: currentPlanFromUrl
      };
    } else {
      $scope.breadcrumbs.middle = null;
    }
  };

  $scope.updateView = () => {
    switch ($scope.searchType) {
      case 'sections':
        $scope.plans =
          siteService.getSectionsByPath($scope.filterSet.getFilter($scope.searchType).value);
        $scope.bakeBreadcrumbs();
        break;
      case 'platforms':
        $scope.plans =
          platformService.getPlatformsByPathAndWebsiteId(
            $scope.filterSet.getFilterValue($scope.searchType),
            $scope.hierarchyFilter.value
          );
        $scope.bakeBreadcrumbs();
        break;
      default:
        break;
    }
  };

  $scope.clearPlans = () => {
    $scope.filterSet.getFilter('platforms').changeValue(null);
    $scope.filterSet.getFilter('sections').changeValue(null);
  };
}


const arr = [
  '$scope',
  '$log',
  '$translate',
  'siteService',
  'platformService',
  '$q',
  TwpBreadcrumbsController
];


export default function (ngModule) {
  ngModule.controller('TwpBreadcrumbsController', arr);
}
